import { useEffect } from "react";

// Smooth scroll to section by id
export function useScrollToHash() {
  useEffect(() => {
    if (window.location.hash) {
      const el = document.querySelector(window.location.hash);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, []);
}

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

// Faculty/Committee monogram avatar. If `image` is provided it renders the
// photograph; otherwise falls back to elegant initials on the champagne tile.
// `imagePosition` allows fine-tuning the crop per photo (CSS object-position).
export function Monogram({
  initials,
  image,
  name,
  size = "lg",
  imagePosition = "50% 18%",
  testId,
}) {
  const sizeMap = {
    sm: "w-14 h-14 text-lg",
    md: "w-20 h-20 text-2xl",
    lg: "w-28 h-28 text-3xl",
    xl: "w-32 h-32 sm:w-36 sm:h-36 text-4xl",
  };
  if (image) {
    return (
      <div
        data-testid={testId}
        className={`${sizeMap[size]} relative overflow-hidden border border-[#C5A059]/50 bg-[#FBF8F1]`}
      >
        <img
          src={image}
          alt={name || initials}
          className="absolute inset-0 w-full h-full object-cover"
          style={{ objectPosition: imagePosition }}
          loading="lazy"
        />
      </div>
    );
  }
  return (
    <div
      data-testid={testId}
      className={`${sizeMap[size]} flex items-center justify-center border border-[#C5A059]/50 bg-[#FBF8F1] text-[#0F5C46] font-serif tracking-wide`}
    >
      {initials}
    </div>
  );
}

// Decorative thin gold rule
export function GoldRule({ className = "" }) {
  return <div className={`gold-rule ${className}`} />;
}

// Overline label (section eyebrow)
export function Overline({ children, testId }) {
  return (
    <p
      data-testid={testId}
      className="text-[11px] font-bold uppercase tracking-[0.28em] text-[#A4863F]"
    >
      {children}
    </p>
  );
}
